{
  "resourceType": "Medication",
  "id": "e2EZ-EIWL0MgLNKiu82bBi4U5EOMgzjQrYlPdxIT7Pxlji02w0YZqo.Le1lXbzRGy3",
  "code": { "text": "ampicillin IVPB 1 g  in 50 mL (Mini-Bag Plus)" },
  "ingredient": [
    {
      "itemReference": {
        "reference": "Medication/eOfOegZp89vpxurBzV3gnRw3",
        "display": "ampicillin"
      },
      "strength": {
        "numerator": {
          "value": 1,
          "unit": "g",
          "system": "http://unitsofmeasure.org",
          "code": "g"
        },
        "denominator": {
          "value": 100,
          "unit": "mL",
          "system": "http://unitsofmeasure.org",
          "code": "mL"
        }
      }
    },
    {
      "itemReference": {
        "reference": "Medication/etFljppYv7KjLyRuKqJ2ypw3",
        "display": "sodium chloride 0.9 %"
      },
      "strength": {
        "numerator": {
          "value": 100,
          "unit": "mL",
          "system": "http://unitsofmeasure.org",
          "code": "mL"
        },
        "denominator": {
          "value": 100,
          "unit": "mL",
          "system": "http://unitsofmeasure.org",
          "code": "mL"
        }
      }
    }
  ]
}
